import { Component, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { SharedService } from 'src/app/modules/gasprecio/services/shared.service';

@Component({
  selector: 'app-select-statistics-sales',
  templateUrl: './select-statistics-sales.component.html',
  styleUrls: ['./select-statistics-sales.component.scss']
})
export class SelectStatisticsSalesComponent implements OnDestroy {

  public items: any[] = [
    { name: 'Promedio', value: 'avg' },
    { name: 'Acumulado', value: 'accum' }
  ];

  public statisticSelected: any = [];
  public ngxDisabled = true;
  statisticSelected$: Subscription;

  constructor(
    public sanitizer: DomSanitizer,
    private sharedService: SharedService
  ) {
    this.statisticSelected$ = sharedService.sharedStatisticSales.subscribe((statisticSelected: string) => {
      if (this.statisticSelected !== statisticSelected) {
        this.statisticSelected = statisticSelected;
      }
    });
  }

  public style(data: string): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(data);
  }

  ngOnDestroy() {
    this.statisticSelected$.unsubscribe();
  }

  changeVariable(event: any) {
    this.statisticSelected = event;
    this.sharedService.nextStatisticSales = this.statisticSelected;
  }

}
